import {productListGet, mergeProductPost, mapBillToList} from "../Model/ProductModel";
import {get, post} from "../../../../GlobalModules/Utility/Http";

/**
 * Fetch product list with optional filters
 * @param {Object} filters - Filter parameters for the API call
 * @returns {Promise} Processed product list data
 */
export const getProductList = async (filters = {}) => {
    // Format filters according to the API structure in Postman collection
    let queryParams = {};

    if (filters) {
        // Handle search term
        if (filters.search) {
            queryParams.filter_op = JSON.stringify({search_attr: "substring"});
            queryParams.filters = {
                limit: filters.limit || 10,
                offset: filters.offset || 0,
                search_attr: filters.search,
            };

            if (filters.store_id) {
                queryParams.filters.store_id = filters.store_id
            }

            if (filters.supplier_id) {
                queryParams.filters.supplier_id = filters.supplier_id
            }

            if(filters?.is_ingredient){
              queryParams.filters.is_ingredient = filters.is_ingredient
            }

            queryParams.filters = JSON.stringify(queryParams.filters);
        } else {
            // Handle pagination and sorting
            const filtersObj = {
                limit: filters.limit || 10,
                offset: filters.offset || 0,
                store_id: filters.store_id
            };

            queryParams.filters = JSON.stringify(filtersObj);
        }
    }

    const response = await get(`${process.env.EXTENDED_URL}/product/list`, queryParams);
    return productListGet(response);
};

/**
 * Merge product
 * @param {Object} - Data to merge product
 * @returns {Promise} Merge response
 */
export const mergeProduct = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL}/stock_transfer/product/merge`, data);
    return mergeProductPost(response);
};

/**
 * Reject product
 * @param {slack} - Transfer product slack
 * @returns {Promise} Reject response
 */
export const rejectProduct = async (slack) => {
    const response = await post(`${process.env.EXTENDED_URL}/stock_transfer/product/reject/${slack}`);
    return mergeProductPost(response);
};

export const loadBillToListApi = async (keywords, type) => {
  try {
    const normalizedType = String(type || 'CUSTOMER').toUpperCase()
    const trimmed = String(keywords || '').trim()

    // Don't make API call if keywords is empty or just whitespace
    if (!trimmed || trimmed.length === 0) {
      return { success: true, data: [] }
    }

    const body = {
      keywords: trimmed,
      type: normalizedType,
      store_id: localStorage.getItem('store_id')
    }
    const response = await post(
      `${process.env.EXTENDED_URL}common/load_bill_to_list`,
      body
    )
    return mapBillToList(response)
  } catch (error) {
    return mapBillToList(error?.response || {})
  }
}